
import React, {Component} from 'react';
import { connect } from 'react-redux';
// Components
import Footer from 'components/presentational/Footer';
import ReplaySection from 'components/presentational/ReplaySection';
import InsuranceBenefitsSVG from 'components/svg/InsuranceBenefitsSVG.js';
import InsuranceBenefitsSVGNonTCA from 'components/svg/InsuranceBenefitsSVGNonTCA.js';
import GTMPush from 'components/GTMPush'

// Functions
import {
    setSectionAsAnimated,
    setAudioToPlay,
    incrementAudioPlayCount,
    stopAudio
} from 'redux/actions';

import animation from './animation.js';
// Files
import './insurance-benefits.scss'

const mapStateToProps = state => {
    return {
        volumeIsOn: state.volumeIsOn,
        animatedSections: state.animatedSections,
        userInteracted: state.userInteracted,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSectionAsAnimated: (val) => dispatch(setSectionAsAnimated(val)),
        setAudioToPlay: (audioKey) => dispatch(setAudioToPlay(audioKey)),
        incrementAudioPlayCount: () => dispatch(incrementAudioPlayCount()),
        stopAudio: () => dispatch(stopAudio())
    };
};

class ConnectedInsuranceBenefits extends Component {
    constructor() {
        super();
        this.audio = React.createRef();

        // Bindigs
        this.handleReplayClick = this.handleReplayClick.bind(this);
        this.playAudio = this.playAudio.bind(this);
    }
    
    componentDidMount() {
        if (this.props.userInteracted && !this.props.animatedSections.some(el => el === this.props.id)) {
            this.animateSection();
        } else {
            // This will fire if we went back a page. If so, stop the current audio from playing.
            this.props.stopAudio();
        }
    }

    componentWillUpdate(nextProps) {
        if (nextProps.userInteracted && !this.props.userInteracted) {
            this.animateSection();
        }
    }

    componentWillUnmount() {
        this.props.setSectionAsAnimated(this.props.id);
    }

    playAudio() {
        // Non-TCA versus TCA audio is chosen via ENV variable `process.env.REACT_APP_NON_TCA`.
        // This logic is implemented within the 'src/model/all-audio.js' file, which is pulled
        // into our main redux recucer in 'src/redux/reducers/index.js'.
        this.props.setAudioToPlay('InsuranceBenefits');

        this.props.incrementAudioPlayCount();
    }

    animateSection() {
        animation(this.playAudio, this.props.nonTca);
    }
    
    handleReplayClick() {
        this.animateSection();
    }

    render() {
        const TCAContent =  <div className="col-one-third insurance-benefits__column-text">
            <p><strong>The payment</strong></p>

            <p>You have two payment options. You can get a Total Control Account (TCA) or we can mail a check to you.</p>

            <p>With a TCA, you can: <br/>
                •  Withdraw funds in small amounts <br/>
                • Or, write one draft for the account’s entire amount 
            </p>

            <p>The TCA account: <br/>
                •  Earns interest from day one <br/>
                •  Has a minimum guaranteed rate <br/>
                •  Has no monthly fees
            </p>
        </div>

        const NonTCAContent =  <>
            <div className="col-one-third insurance-benefits__column-text">
                <p><strong>The payment</strong></p>

                <p>Once your claim is approved, the proceeds will be released right away in the form of a check. Refer to your claim form for more details on how your payment will be processed. </p>
            </div>

            <InsuranceBenefitsSVGNonTCA className="insurance-benefits__image insurance-benefits__image--graph" />
        </> 

        return (
            <div className="insurance-benefits text-center">
            
                <GTMPush 
                  event="pageLoad" 
                  virtualPath={this.props.location.pathname} 
                  pageNo="05" 
                  pageName={this.props.pageName} 
                  quizAnswer="undefined" />
                  
                <div className="container">
                    <h1 className="insurance-benefits__heading heading-1">Step 4: Receive your life insurance benefits</h1>
                    
                    <div className="row insurance-benefits__content">
                        <div className="col-one-third insurance-benefits__column">
                            <div className="insurance-benefits__column-text">
                                <p><strong>The decision</strong></p>

                                <p>Once you’ve submitted, you can check the status of your claim online or via email or text if you selected one of these options when completing the claim form. Otherwise, we’ll automatically notify you by mail.</p>

                                <p>Once you’ve submitted, we’ll  review everything within 5 business days, and you’ll usually receive a decision within that time. If we need more information from you, we’ll let you know.</p>
                            </div>
                            
                        </div>
                        
                        <div className="col-one-third insurance-benefits__column">
                            {this.props.nonTca ? NonTCAContent : TCAContent }
                        </div>
                        

                        <div className="col-one-third insurance-benefits__column" >
                            <div className="insurance-benefits__column-text">
                                <p><strong>Additional support</strong></p>

                                <p>You may also be eligible for other MetLife benefits intended to help you cope with your loss, including:</p>

                                <p>
                                    •  Grief counseling <br/>
                                    •  Legal help for estate issues 
                                </p>
                            </div>
                            
                            <InsuranceBenefitsSVG className="insurance-benefits__image insurance-benefits__image--person" />
                        </div>
                    </div>

                    <ReplaySection handleClick={this.handleReplayClick}/>
                </div>

                <Footer pageIndex={5}/>
            </div>
        )
    }
}

const InsuranceBenefits = connect(mapStateToProps, mapDispatchToProps)(ConnectedInsuranceBenefits);

export default InsuranceBenefits
